import { call, put, takeLatest } from 'redux-saga/effects'
import {
  FETCH_RATESHEET,
  fetchRateSheetFulfilled,
  fetchRateSheetFailed,
} from './actions'
import { fetchRateSheet } from './fetchRateSheet'

function* fetchRateSheetSaga(action) {
  try {
    const rateSheet = yield call(fetchRateSheet)
    yield put(fetchRateSheetFulfilled(rateSheet))
  } catch (e) {
    yield put(e => fetchRateSheetFailed(e.message))
  }
}

export function* rootSaga() {
  yield takeLatest(FETCH_RATESHEET, fetchRateSheetSaga)
}



// WEBPACK FOOTER //
// ./src/sagas.js